var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "send-list-form",
    _vm._b(
      { on: { created: _vm.onCreated } },
      "send-list-form",
      _vm.$props,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }